import { createState } from '../helpers/state-subject';
import { preventAnimation, accessibilityEnabledListener } from '../services/accessibility.service';
const LEFT = -1;
const RIGHT = 1;
const CLICK_BUFFER = 3; // buffer in pixels to prevent a click from being interpreted as a swipe
const DEFAULT_SLIDE_SELECTOR = '.js-utk-carousel-slide';
const DEFAULT_BUTTON_SELECTOR = '.js-utk-carousel-selection';
// TODO: merge with GlobalBanner.js
export class Carousel {
    constructor(container, config, device) {
        this.container = container;
        this.config = config;
        this.device = device;
    }
    config;
    container;
    device;
    slides;
    buttons;
    rotationIntervalId = null;
    selectedSlideStore = createState(undefined);
    setupAc = new AbortController();
    swipeListenersAdded = false;
    setup() {
        // tear down any prior setup-scoped listeners (handles reset cycles)
        this.setupAc.abort();
        this.setupAc = new AbortController();
        this.swipeListenersAdded = false;
        const { signal } = this.setupAc;
        this.slides = Array.from(this.container.querySelectorAll(this.config.slideSelector || DEFAULT_SLIDE_SELECTOR));
        this.buttons = Array.from(this.container.querySelectorAll(this.config.buttonSelector || DEFAULT_BUTTON_SELECTOR));
        if (this.slides.length > 1) {
            console.log(`${this.constructor.name}: setting up carousel for ${this.device}`);
            const unsubSlide = this.selectedSlideStore.subscribe((id) => {
                this.slides.forEach((b) => {
                    if (b.dataset.id === id) {
                        b.classList.add("selected");
                    }
                    else {
                        b.classList.remove("selected");
                    }
                });
                this.buttons.forEach((b) => {
                    if (b.dataset.id === id) {
                        b.classList.add("selected");
                    }
                    else {
                        b.classList.remove("selected");
                    }
                });
            });
            signal.addEventListener('abort', () => unsubSlide());
            this.selectedSlideStore.set(this.slides[0].dataset.id);
            this.buttons.forEach((button) => {
                button.addEventListener('click', (e) => {
                    const el = e.currentTarget;
                    if (el.classList.contains("selected")) {
                        return;
                    }
                    this.selectedSlideStore.set(el.dataset.id);
                    this.resetRotation();
                }, { signal });
            });
            this.startRotation();
            this.container.addEventListener('mouseenter', () => this.stopRotation(), { signal });
            this.container.addEventListener('mouseleave', () => this.startRotation(), { signal });
            const unsubA11y = accessibilityEnabledListener().subscribe(() => this.stopRotation());
            signal.addEventListener('abort', () => unsubA11y());
            if (this.device === "mobile" && !this.swipeListenersAdded) {
                this.addSwipeListeners(this.container, signal);
            }
        }
        else if (this.slides.length === 1) {
            console.log(`GlobalBanner: setting up for one global banner for ${this.device}`);
            this.slides[0].classList.add("global-banner__banner--selected");
            // single slide: no rotation needed
        }
    }
    reset() {
        this.debug("refreshing setup");
        this.stopRotation();
        this.setup();
    }
    getNextSlideId(direction) {
        const selectedIdx = this.slides.findIndex((b) => b.classList.contains("selected"));
        const nextIdx = selectedIdx + (direction * 1);
        const newIdx = nextIdx === (this.slides.length) ? 0 : nextIdx === -1 ? this.slides.length - 1 : nextIdx;
        const nextSlide = this.slides[newIdx];
        return nextSlide.dataset.id;
    }
    stopRotation() {
        this.debug("stopping rotation");
        if (this.rotationIntervalId !== null) {
            clearInterval(this.rotationIntervalId);
            this.rotationIntervalId = null;
        }
    }
    startRotation() {
        const rotationSpeed = this.config.rotation;
        if (!preventAnimation() && this.rotationIntervalId === null) {
            this.debug("starting rotation");
            if (rotationSpeed) {
                const rotationMillis = +rotationSpeed * 1000;
                this.rotationIntervalId = setInterval(() => {
                    this.selectedSlideStore.set(this.getNextSlideId(RIGHT));
                }, rotationMillis);
            }
        }
    }
    resetRotation() {
        this.debug("resetting rotation");
        this.stopRotation();
        this.startRotation();
    }
    addSwipeListeners(el, signal) {
        this.debug("adding swipe listeners");
        let touchstartX = 0;
        let touchendX = 0;
        el.addEventListener('touchstart', e => {
            this.debug("touchstart");
            touchstartX = e.changedTouches[0].screenX;
        }, { passive: true, signal });
        el.addEventListener('touchend', e => {
            this.debug("touchend");
            touchendX = e.changedTouches[0].screenX;
            const diff = Math.abs(touchstartX - touchendX);
            if (diff < CLICK_BUFFER) {
                // click
                return;
            }
            let direction = RIGHT;
            if (touchendX > touchstartX) {
                direction = LEFT;
            }
            this.selectedSlideStore.set(this.getNextSlideId(direction));
            this.resetRotation();
        }, { signal });
        this.swipeListenersAdded = true;
    }
    debug(msg) {
        console.debug(`${this.constructor.name} ${this.device || ""}: ${msg}`);
    }
}
